import { render, staticRenderFns } from "./BidsAddBulkPricingTableMatchTypeColumn.vue?vue&type=template&id=f1019022"
import script from "./BidsAddBulkPricingTableMatchTypeColumn.vue?vue&type=script&lang=js"
export * from "./BidsAddBulkPricingTableMatchTypeColumn.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports